// Great Eastern General on the add-ons step (Ansa-Support#124).
//
// Priced by Great Eastern through the server, exactly like Pacific & Orient (see poiQuote.js):
// "Next" and every add-on toggle re-quote /api/motor/get-quote-great-eastern, and the server
// records that quote for the /motor/store price floor and re-prices again at issuance. Without
// this branch the page would fall into its browser formula, and Great Eastern's issuance guard
// refuses to bind at a price other than its own — a paid order with no cover note.

import { serverPricedPlanFromQuote } from "./poiQuote";

export const GREAT_EASTERN_INSURER_NAME = "GREAT EASTERN";

export const isGreatEasternPlan = (plan) =>
	String(plan?.insurer_name || "")
		.trim()
		.toUpperCase() === GREAT_EASTERN_INSURER_NAME;

export const greatEasternPlanFromQuote = serverPricedPlanFromQuote(
	GREAT_EASTERN_INSURER_NAME,
	"Great Eastern could not price this quote. Please try again.",
);
